module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vbassets/_next/static/images/badge-2e976ad60aeb5cd5dff601ae65cfba17.svg";